<template>
	<div class="supplier-wallet">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Finance Handling Fee</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="row">
				<div class="page-scoreboard col-md-3">
					<div class="box box--primary mb-md-0 mh-120">
						<div class="m-2">
							<h4
								class="text-accent font-weight-bold mb-0"
								:class="{ 'is-loading': isFetching }">
								<span>{{ currency }} {{ formatNumberPlain(scoreBoard.handlingFeeAmount) }}</span>
							</h4>
							<div class="d-flex align-items-baseline justify-content-between">
								<span class="d-block mt-2"><i class="bi bi-wallet"></i> {{ $t('Total Handling Fee') }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="page-scoreboard col-md-3">
					<div class="box box--primary mb-md-0 mh-120">
						<div class="m-2">
							<h4
								class="text-accent font-weight-bold mb-0"
								:class="{ 'is-loading': isFetchingStash }">
								<span>{{ currency }} {{ stashDisplay }}</span>
							</h4>
							<div class="d-flex align-items-baseline justify-content-between">
								<span class="d-block mt-2"><i class="bi bi-stopwatch"></i> {{ $t('Total Stash') }}</span>
								<router-link
									to="/admin/credit/stash/handling_fee">View All
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page-content mt-4">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-3">
							<div class="input-group">
								<!-- Search Supplier -->
								<multiselect v-model="selectedSupplier"
									:show-labels="false"
									class="form-control"
									track-by="_id"
									label="label"
									placeholder="Username / Email"
									:options=optionSupplier
									:loading="isSearchingSupplier"
									@search-change="fetchDataSupplier"
									>
									<span slot="noResult">
										No options matching the query
									</span>
									<span slot="noOptions">
										No options available
									</span>
								</multiselect>
								<!-- <price-input
									class="input form-control"
									min="0"
									v-model="product.cogs"
								></price-input> -->
							</div>
						</div>
						<div class="col-sm-9">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<div class="filter-date">
									<vuejs-datepicker
										class="mr-3"
										v-model="pickedDate"
										:format="'MMMM yyyy'"
										:bootstrap-styling="true"
										:minimum-view="'month'"
										:maximum-view="'year'"
										name="datepicker"
										id="input-id"
										:calendar-button="true"
										:calendar-button-icon="'bi bi-calendar3'"
										:calendar-button-content="''"
										:calendar-class="'bg-white'"
										:input-class="'bg-white'"
										:wrapper-class="'bg-white'">
									</vuejs-datepicker>
								</div>
								<button
									@click="exportData"
									type="button"
									class="btn btn-sm btn-primary"
									:class="{ 'is-loading': isExporting }"
									>
									<i class="material-icons">save_alt</i>
									<span class="mr-2">{{ $t('Export') }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="user-wallet-list table-responsive">
					<table class="user-wallet-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="10%" class="text-left">
									ID Supplier
								</th>
								<th width="25%" class="th-sort text-left" :class="sortClass('supplier.name')"
									@click="changeSorting('supplier.name')">
									Supplier
								</th>
								<th width="15%" class="th-sort text-left" :class="sortClass('billing_cycle')"
									@click="changeSorting('billing_cycle')">
									Periode
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('handling_fee_amount')"
								@click="changeSorting('handling_fee_amount')">
									Handling Fee
								</th>
								<th width="5%"></th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(item, index) in items">
								<tr @click="showDetail(item)" :key="index"
								:class="{ 'highlighted': handlingFeeDetail && handlingFeeDetail._id === item._id }">
									<td>
										{{ item.user_id }}
									</td>
									<td>
										<div class="name">
											{{ item.supplier.name }}
										</div>
										<div class="email">
											{{ item.supplier.email}}
										</div>
									</td>
									<td>
										{{ item.handling_fee_cycle }}
									</td>
									<td class="">
										{{ currency }} {{ formatNumberPlain(item.handling_fee_amount) }}
									</td>
									<td class="">
										<div class="d-flex align-items-center justify-content-end pr-4">
											<i class="material-icons cur-p" v-tooltip="'Show Details'">
												<template v-if="handlingFeeDetail && handlingFeeDetail._id === item._id">keyboard_arrow_up</template>
												<template v-else>keyboard_arrow_down</template>
											</i>
										</div>
									</td>
								</tr>
								<tr
									class="detail-view"
									:key="`${index}-2`"
									v-if="handlingFeeDetail && handlingFeeDetail._id === item._id">
									<td colspan="7">
										<template v-if="item.orders">
											<div
												class="text-center"
												v-if="item.orders.length === 0">
												- {{ $t('No Commission Details') }} -
											</div>

											<div class="p-1" v-else>
												<h6 class="mb-3 text-bold">{{ $t('Detail Handling Fee') }}</h6>
												<div class="card card-body p-3">
													<table class="table table--small">
														<thead>
															<tr>
																<th class="text-left">Order ID</th>
																<th class="text-left">Product</th>
																<th class="text-right">Handling Fee</th>
															</tr>
														</thead>
														<tbody>
															<tr
																v-for="order in handlingFeeOrders"
																:key="order.order_id">
																<td>#{{ order.order_id }}</td>
																<td>{{ order.product }}</td>
																<td class="text-right">
																	{{ currency }} {{ formatNumberPlain(order.fee_amount) }}
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</template>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Handling Fee Found yet.</span>
						<span v-else>No Handling Fees was found</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import vuejsDatepicker from 'vuejs-datepicker';
import {
	duplicateVar,
	formatDate,
	downloadFile,
	getAxiosErrorMessage,
	formatNumberPlain,
} from '@/lib/helper';
import handleFeeApi from '@/api/handle-fee';
import adminApi from '@/api/admin';
import walletStashApi from '@/api/wallet-stash';

export default {
	name: 'AdminHandlingFee',
	components: {
		vuejsDatepicker,
	},
	data() {
		return {
			limit: 25,
			page: 1,
			sort_by: 'handling_fee_amount',
			sort: 'desc',
			isFetching: false,
			isShowDetail: false,
			isSearchingSupplier: false,
			isExporting: false,
			items: [],
			selectedData: {},
			selectedSupplier: null,
			optionSupplier: [],
			last_sync: null,
			isDisabled: true,
			handlingFeeDetail: null,
			handlingFeeOrders: null,
			pickedDate: this.moment().subtract(1, 'months').format(),
			pickedMonth: this.moment().subtract(1, 'months').format('MM'),
			pickedYear: this.moment().subtract(1, 'months').format('YYYY'),
			scoreBoard: {
				handlingFeeAmount: null,
			},
			stashTotal: 0,
			isFetchingStash: false,
			isAll: false,
			keyword: null,
			currency: 'Rp',
		};
	},
	methods: {
		exportData() {
			this.isExporting = true;
			const params = this.getFetchParams();
			params.limit = 9999;

			if (this.items.length < 1) {
				params.is_stash_processed = false;
			}

			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			handleFeeApi.export(params, callback, errorCallback);
		},
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		fetchDataSupplier(query) {
			this.isSearchingSupplier = true;

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: 'supplier',
			};

			const callback = (response) => {
				this.optionSupplier = response.data;
				this.isSearchingSupplier = false;
			};
			const errorCallback = () => {
				this.isSearchingSupplier = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		formatDate,
		getFetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.selectedSupplier) {
				params.supplier_id = this.selectedSupplier._id;
			}

			if (this.pickedMonth) {
				params.picked_month = this.pickedMonth;
			}

			if (this.pickedYear) {
				params.picked_year = this.pickedYear;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				this.isSearchingSupplier = false;
				const items = response.data;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
				this.fetchScoreBoard();
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			handleFeeApi.getList(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.selectedSupplier = null;
		},
		clearFilter() {
			this.$router.replace({ query: null });
			this.resetFilter();
			this.applyFilter();
		},
		showDetail(handlingFeeDetail) {
			if (this.handlingFeeDetail && this.handlingFeeDetail._id === handlingFeeDetail._id) {
				this.handlingFeeDetail = null;
				this.handlingFeeOrders = null;
				return;
			}

			this.handlingFeeDetail = duplicateVar(handlingFeeDetail);
			this.handlingFeeOrders = this.handlingFeeDetail.orders ?? [];
		},
		fetchScoreBoard() {
			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				this.isSearchingSupplier = false;
				this.scoreBoard.handlingFeeAmount = response.data;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			handleFeeApi.getScoreBoard(params, callback, errorCallback);
		},
		getStashBalance() {
			this.isFetchingStash = true;
			const callback = (response) => {
				this.isFetchingStash = false;
				const total = response.data;
				this.stashTotal = total;
			};
			const errorCallback = (e) => {
				this.isFetchingStash = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Stash Balance',
					text: message,
				});
			};

			const params = {
				type: 'handling_fee',
			};
			walletStashApi.getTotal(callback, errorCallback, params);
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
		}),
		isFilterOn() {
			return this.selectedSupplier !== null;
		},
		stashDisplay() {
			return formatNumberPlain(this.stashTotal);
		},
	},
	watch: {
		selectedSupplier() {
			if (this.selectedSupplier) {
				this.fetchItems(true);
			}
		},
		pickedDate() {
			const date = this.moment(this.pickedDate);
			this.pickedMonth = date.format('MM');
			this.pickedYear = date.format('YYYY');
			this.fetchItems(true);
		},
	},
	created() {
		this.fetchItems();
		this.getStashBalance();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
	.vdp-datepicker__calendar .cell.selected {
		background: '$primary_color' !important;
	}
</style>
